import { ApplicationData } from "../applicationData";
/**
 * @deprecated Use window directly
 */
export function getPreloadWindow() {
    return window;
}
/**
 * @deprecated Use window.api directly
 */
export function getPreloadApi() {
    return getPreloadWindow().api;
}
/**
 * @deprecated Use ApplicationData directly
 */
export function getWindowId() {
    const windowId = ApplicationData.instance.windowId;
    if (windowId === undefined) {
        throw new Error("ApplicationData not initialized. Call ApplicationData.init() first.");
    }
    return windowId;
}
/**
 * @deprecated Use ApplicationData directly
 */
export function getAppName() {
    const name = ApplicationData.instance.name;
    if (name === undefined) {
        throw new Error("ApplicationData not initialized. Call ApplicationData.init() first.");
    }
    return name;
}
/**
 * @deprecated Use ApplicationData directly
 */
export function getAppVersion() {
    const version = ApplicationData.instance.version;
    if (version === undefined) {
        throw new Error("ApplicationData not initialized. Call ApplicationData.init() first.");
    }
    return version;
}
